import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    standalone: true,
    name: 'dateTime'
})
export class DateTimePipe implements PipeTransform {

    transform(value: string | Date, format: Intl.DateTimeFormatOptions = {}): string {
        if (!value) return '';

        // Falls String mit Mikrosekunden → auf Millisekunden kürzen
        const cleaned = typeof value === 'string'
            ? value.split('.')[0] // "2025-03-24T08:13:12"
            : value;

        const date = new Date(cleaned);

        if (isNaN(date.getTime())) return value.toString(); // ungültiges Datum

        // Standardformat, falls nicht übergeben
        const defaultFormat: Intl.DateTimeFormatOptions = {
            year: 'numeric',
            month: '2-digit',
            day: '2-digit',
            hour: '2-digit',
            minute: '2-digit',
            second: '2-digit'
        };

        return new Intl.DateTimeFormat('de-DE', { ...defaultFormat, ...format }).format(date);
    }
}
